import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dayjs from 'dayjs'
import Wow from 'wow.js'
import VueLazyload from 'vue-lazyload'

import registerComponents from '@/components'
import { parallax, IsPC } from '@/utils'
import './element'
import './vant'
import '@/styles/index.scss'
import 'animate.css'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

if (process.env.DISABLED_SENTRY !== 'yes') {
  Sentry.init({
    environment: process.env.VUE_APP_MODE,
    Vue,
    dsn: 'https://f5ee716451e844a494cb2a2dbcd14513@o414797.ingest.sentry.io/4504806543785984',
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ['localhost', 'local.jin10.com', /^\//]
      }),
      new Sentry.Replay({
        maskAllText: false
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    logErrors: true

  })
}

Vue.prototype.IsPC = IsPC()

Vue.prototype.dayjs = dayjs

Vue.config.productionTip = false
registerComponents(Vue)
Vue.use(VueLazyload)
Vue.use(parallax)

new Vue({
  router,
  store,
  mounted() {
    new Wow().init()
  },
  render: h => h(App)
}).$mount('#app')
